import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './BodyMassRecord.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import Modal from '../../../../components/comm/Modal';
import ToastPopup from '../../../../components/comm/ToastPopup';
import noDataImg from '../../../../images/common/i_3d_no_data_doc.svg';
import URL from '../../../../constants/url';
import BodyMassRecordBox from '../../../../components/home/bodymass/BodyMassRecordBox';
import LineGraphBox from '../../../../components/home/LineGraphBox';
import BottomSheetBase from '../../../../components/comm/BottomSheetBase';
import { useNavigate, useLocation } from 'react-router-dom';
// import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import Skeleton from '@mui/material/Skeleton';
import axiosApi from '../../../../api/daonAxios';

const BodyMassRecord = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [recordList, setRecordList] = useState([]);
    const [bmiList, setBmiList] = useState([]);
    const [graphRecords, setGraphRecords] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [visibleCount, setVisibleCount] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [isInitialLoading, setIsInitialLoading] = useState(true);

    const [guideOpen, setGuideOpen] = useState(false);

    const confirmDelete = (index) => { setDeleteIndex(index); setIsOpen(true); };

    const handleConfirmDelete = () => {
        if (deleteIndex !== null) { handleDelete(deleteIndex); setDeleteIndex(null); }
        setIsOpen(false);
    };

    const parseDateTime = (dateStr, timeStr) => {
        return new Date(
            parseInt(dateStr.substring(0, 4)), parseInt(dateStr.substring(4, 6)) - 1,
            parseInt(dateStr.substring(6, 8)), parseInt(timeStr.substring(0, 2)),
            parseInt(timeStr.substring(2, 4)), parseInt(timeStr.substring(4, 6))
        );
    };

    const updateList = (records) => {
        const sorted = [...records].sort((a, b) => parseDateTime(b.recDe, b.recTm) - parseDateTime(a.recDe, a.recTm));
        setRecordList(sorted);
    };

    const updateGraphData = (records) => {
        if (!records || records.length === 0) return;
        const sorted = [...records].sort((a, b) => parseDateTime(b.recDe, b.recTm) - parseDateTime(a.recDe, a.recTm));
        const latest = sorted.slice(0, 3).sort((a, b) => parseDateTime(a.recDe, a.recTm) - parseDateTime(b.recDe, b.recTm));
        setBmiList(latest.map(r => r.bmi));
        setGraphRecords(latest.map(r => ({ ...r, date: formatDateStr(r.recDe), time: convertTimeStr(r.recTm) })));
    };

    const handleDelete = (usrBmiHistId) => {

        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            data : {usrBmiHistId : usrBmiHistId},
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        axiosApi.delete('/bmi',requestOption)
        .then((res) => {
            setToastMessage('기록이 삭제되었습니다.'); 
            setToast(true); 
            getUsrBmiHist();
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {
            setIsInitialLoading(false);
        })


    };

    const convertTimeStr = (t) => `${t.substring(0, 2)}:${t.substring(2, 4)}`;
    const formatDateStr = (d) => d ? `${d.substring(2, 4)}.${d.substring(4, 6)}.${d.substring(6, 8)}` : '';
    const formatLatestDateStr = (d) => d ? `${d.substring(0, 4)}.${d.substring(4, 6)}.${d.substring(6, 8)}` : '';

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            getUsrBmiHist();
        }
    }, []);

    const getUsrBmiHist = useCallback(async () => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.get('/bmi/list',requestOption)
        .then((res) => {
            const list = res.data.result;
            setRecordList(list);
            updateGraphData(list); 
            updateList(list);
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {
            setIsInitialLoading(false);
        })

    }, []);

    useEffect(() => {
        if (location.state?.showToast) {
            setToastMessage(location.state.toastMessage);
            setToast(true);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, location.pathname, navigate]);

    const handleBack = () => { navigate(URL.HOME_MAIN, { replace: true, state: { tabIndex: 1 } }); };

    const loadMore = () => {
        if (isLoading) return;
        setIsLoading(true);
        setTimeout(() => { setVisibleCount(prev => Math.min(prev + 10, recordList.length)); setIsLoading(false); }, 300);
    };

    const observerRef = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) loadMore(); }, { threshold: 1 });
        if (observerRef.current) observer.observe(observerRef.current);
        return () => { if (observerRef.current) observer.unobserve(observerRef.current); };
    }, [recordList, visibleCount]);

    const SkeletonLoader = () => (
        <>
            <div className={style['graph-box']}>
                <div className={style['graph-top']}><Skeleton variant="text" width={150} height={24} /><Skeleton variant="text" width={80} height={24} /></div>
                <div className={style['graph-bot']}><div className={style['inner-box']}><Skeleton variant="rectangular" width="100%" height={110} style={{ borderRadius: '12px' }} /></div></div>
            </div>
            <div className="inner-wrap"><div className={style['record-box-lists']}><ul>
                {[...Array(3)].map((_, idx) => (
                    <li key={idx} style={{ width: "100%", height: '120px', padding: '16px', marginBottom: '12px', backgroundColor: '#fff', borderRadius: '12px' }}>
                        <Skeleton variant="text" width={80} height={24} style={{ borderRadius: '4px', marginBottom: '2px' }} />
                        <Skeleton variant="text" width={'80%'} height={20} style={{ borderRadius: '4px', marginBottom: '2px' }} />
                        <Skeleton variant="text" width={'60%'} height={20} style={{ borderRadius: '4px', marginBottom: '2px' }} />
                        <Skeleton variant="text" width={120} height={22} style={{ borderRadius: '4px', marginBottom: '6px' }} />
                    </li>
                ))}
            </ul></div></div>
        </>
    );


    /////////////////////


    return (
        <>
            <HeadSub title="체질량 기록" onBack={handleBack}
                rightArea={
                    <button className='btn' data-btn-type="fill-main-sub" data-btn-size='sm' onClick={() => setGuideOpen(true)}
                    >
                        <span>체질량 기록 가이드</span> 
                    </button>
                }
            />

            <div id="sub-content" tabIndex={-1}>
                {isInitialLoading ? (
                    <SkeletonLoader />
                ) : recordList.length === 0 ? (
                    <div className='animation-3'>
                        <div className={style['no-data-box']}>
                            <div className={style['img-box']}><object data={noDataImg} aria-hidden='true' /></div>
                            <p>기록이 없습니다.</p>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className={style['graph-box']}>
                            <div className={style['graph-top']}>
                                <p>{formatLatestDateStr(recordList[0].recDe)} {convertTimeStr(recordList[0].recTm)}</p>
                                <ul className={style['legend-box']}>
                                    <li data-status="2"><p>BMI</p><span>{bmiList.length > 0 ? bmiList[bmiList.length - 1] : ''}</span></li>
                                </ul>
                            </div>
                            <div className={style['graph-bot']}>
                                <div className={style['inner-box']}>
                                    <ul className={style['line-graph-box']}>
                                        <li><LineGraphBox data={{ columns: [bmiList] }} graphColor={["#1065D9"]} height={10} /></li>
                                    </ul>
                                    <div className={style['line-graph-date-box']}>
                                        <ul data-graph-length={recordList.length === 2 ? "twin" : ""}>
                                            {graphRecords.map((item, idx) => (
                                                <li key={idx}><div className={style['date-text']}><p>{formatDateStr(item.recDe)}</p><span>{convertTimeStr(item.recTm)}</span></div></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="inner-wrap">
                            <div className={style['record-box-lists']}>
                                <ul>
                                    {recordList.slice(0, visibleCount).map((item, idx) => (
                                        <li key={idx}>
                                            <BodyMassRecordBox stature={item.height} weight={item.bdwgh} bmi={item.bmi} usrBmiHistId={item.id}
                                                date={formatDateStr(item.recDe)} time={convertTimeStr(item.recTm)} rsltCd={item.rsltCd}
                                                onDelete={() => confirmDelete(item.id)} />
                                        </li>
                                    ))}
                                </ul>
                                {visibleCount < recordList.length && <div ref={observerRef} style={{ height: '1px' }} />}
                            </div>
                        </div>
                    </>
                )}

                <div className="bottom-fixed-box">
                    <div className="inner-box" data-bg-color="transparent">
                        <div className='btn-layout' data-btn-num="1">
                            <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={() => navigate(URL.BODY_MASS_WRITE)}><span>체질량 기록하기</span></button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'><div className='title-box'><p>기록을 삭제하시겠어요?</p></div></div>
                    <div className="modal-bottom-box"><div className='btn-layout'>
                        <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={() => setIsOpen(false)}><span>아니요</span></button>
                        <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleConfirmDelete}><span>네</span></button>
                    </div></div>
                </div>
            </Modal>



            <BottomSheetBase open={guideOpen} onDismiss={() => setGuideOpen(false)} maxHeight="75vh"
                    footer={
                        <div>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="lg"
                                style={{ width: '100%' }}
                                onClick={() => setGuideOpen(false)}>
                                <span>확인</span>
                            </button>
                        </div>
                    }
                >
                    <div className={style['guide-sheet-wrap']}>
                        <h3>체질량 기록 가이드</h3>
                        <ul className={style['guide-content']}>
                            <li>
                                우리나라의 비만 기준: 성인 비만의 기준은 체질량지수 25 kg/㎡ 이상입니다.
                            </li>
                            <li>
                                체질량 지수 25.0 ~ 29.9 kg/㎡를 1단계 비만, 30.0 ~ 34.9 kg/㎡를 2단계 비만, 35.0 kg/㎡ 이상을 3단계 비만(고도 비만)으로 구분합니다
                            </li>
                        </ul>
                        <table>
                            <thead>
                                <tr>
                                    <th>구분</th>
                                    <th>범위</th>
                                    <th>설명</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>저체중</td>
                                    <td>18.5 미만</td>
                                    <td>-</td>
                                    
                                </tr>
                                <tr>
                                    <td>정상</td>
                                    <td>18.5 ~ 22.9</td>
                                    <td>건강한 체중</td>
                                </tr>
                                <tr>
                                    <td>주의</td>
                                    <td>23.0 ~ 24.9</td>
                                    <td>과체중 (비만 전 단계)</td>
                                </tr>
                                <tr>
                                    <td>위험</td>
                                    <td>25.0 이상</td>
                                    <td>비만 (1단계 이상)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </BottomSheetBase>

            {toast && <ToastPopup setToast={setToast} message={toastMessage} position="center" opacity="90" />}
        </>
    );
};

export default BodyMassRecord;